// Turbo のページキャッシュ前に、ページ内の動画・音声を止める。
// Turbo はページ離脱時に cloneNode(true) でスナップショットを取る。video.muted はプロパティなので複製に引き継がれず、
// autoplay 属性だけが残ると、document 外の複製が「ミュートなし」で再生され続け、一覧に戻っても音が止まらなくなる。
// キャッシュ前に止めて autoplay を外しておけば、複製は再生されない(戻ったときは各画面の JS が作り直す)。

export function pauseMediaForCache(root) {
  if (!root || typeof root.querySelectorAll !== "function") return

  root.querySelectorAll("video, audio").forEach((media) => {
    if (typeof media.pause === "function") media.pause()
    media.removeAttribute("autoplay")
  })
}

document.addEventListener("turbo:before-cache", () => {
  pauseMediaForCache(document)
})
